"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkInstanceOf = checkInstanceOf;
// Function to check for deep inheritance.  The native instanceof does not work correctly with transpiled code
function checkInstanceOf(prototype, base) {
  // if this object has a prototype then we are not looking at the prototype right now
  if (!prototype || !base) {
    return false;
  }
  if (prototype.prototype) {
    return checkInstanceOf(prototype.prototype, base);
  }
  if (base.prototype) {
    return checkInstanceOf(prototype, base.prototype);
  }
  // make sure this isn't a primative class, those are always false
  if (!prototype.constructor || prototype.constructor.name == "Object" || prototype.constructor.name == "Array" || prototype.constructor.name == "String" || prototype.constructor.name == "Number" || prototype.constructor.name == "Boolean") {
    return false;
  }
  // check for a match
  if (base.constructor && base.constructor.name == prototype.constructor.name || base.prototype && base.prototype.constructor && base.prototype.constructor.name == prototype.constructor.name || prototype.constructor.name == base) {
    return true;
  }
  return checkInstanceOf(prototype.__proto__, base);
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(checkInstanceOf, "checkInstanceOf", "src/core_modules/base-contentmodel/utils.js");
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/base-contentmodel/utils.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/base-contentmodel/utils.js
// module chunks = 0